import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";

function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");

    // ✅ Password match validation
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/api/auth/signup`, {
        name,
        email,
        password
      });

      alert("Signup successful. Please login.");
      navigate("/login");
    } catch (err) {
      setError(
        err.response?.data?.message ||
        "Signup failed. Email may already exist."
      );
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>Create Account</h2>
        <p className="login-subtitle">
          Register to access the college portal
        </p>

        <form onSubmit={handleSignup}>
          <div className="input-group">
            <label>Name</label>
            <input
              type="text"
              placeholder="Enter full name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Create password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label>Confirm Password</label>
            <input
              type="password"
              placeholder="Re-enter password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <p style={{ color: "red", fontSize: "14px", marginBottom: "10px" }}>
              {error}
            </p>
          )}

          <button type="submit" className="login-btn-main">
            Signup
          </button>
        </form>
      </div>
    </div>
  );
}

export default Signup;







// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// function Signup() {
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [error, setError] = useState("");

//   const navigate = useNavigate();

//   const handleSignup = async (e) => {
//     e.preventDefault();
//     setError("");

//     // ✅ Password match validation
//     if (password !== confirmPassword) {
//       setError("Passwords do not match");
//       return;
//     }

//     try {
//       await axios.post("http://localhost:5000/api/auth/signup", {
//         name,
//         email,
//         password
//       });
//       alert("Signup successful. Please login.");
//       navigate("/login");
//     } catch {
//       setError("Signup failed. Email may already exist.");
//     }
//   };

//   return (
//     <div className="login-page">
//       <div className="login-card">
//         <h2>Create Account</h2>
//         <p className="login-subtitle">
//           Register to access the college portal
//         </p>

//         <form onSubmit={handleSignup}>
//           <div className="input-group">
//             <label>Name</label>
//             <input
//               type="text"
//               placeholder="Enter full name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               required
//             />
//           </div>

//           <div className="input-group">
//             <label>Email</label>
//             <input
//               type="email"
//               placeholder="Enter email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//           </div>

//           <div className="input-group">
//             <label>Password</label>
//             <input
//               type="password"
//               placeholder="Create password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//           </div>

//           <div className="input-group">
//             <label>Confirm Password</label>
//             <input
//               type="password"
//               placeholder="Re-enter password"
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//               required
//             />
//           </div>

//           {/* ERROR MESSAGE */}
//           {error && (
//             <p style={{ color: "red", fontSize: "14px", marginBottom: "10px" }}>
//               {error}
//             </p>
//           )}

//           <button type="submit" className="login-btn-main">
//             Signup
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default Signup;
